import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HqfilterState } from 'types';

export const initialState: HqfilterState = {
  loading: false,
  hqfilterList: [],
  hqfilterOriginalList: [],
  reset: false,
  countryCode:'us',
  filter: {
    manufacture: '',
    distributor: ''
  }
};

const slice = createSlice({
  name: 'Hqfilter',
  initialState,
  reducers: {
    setHqfilterList: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.hqfilterList = payload || [];
      state.reset = false;
    },
    reset: (state) => {
      state.reset = true;
    },
    setCountry: (state, { payload }: PayloadAction<any>) => {
      state.countryCode = payload;
    },

    setHqFilter: (state, { payload }: PayloadAction<any>) => {
      const filter = { ...payload };

      state.filter = { ...state.filter, ...filter };
    },
   
  }
});

export const { setHqfilterList, setCountry, reset ,setHqFilter} = slice.actions;

export default slice.reducer;
